import ouiBase from '@goldwasserexchange/oui';
import { useAccountPositionsHistoryFieldApiByHisMvtId } from '../api';

export const useAccountPositionsHistoryHisMvtPriceOpe = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountPositionsHistoryFieldApiByHisMvtId({
    hisMvtId,
    field: 'HIS_MVT.PRICE_OPE',
  });
  return result;
};
